<template>
  <v-card class="elevation-1 mb-6 rounded-lg mt-0">
    <v-card-title class="pa-7">
      Schvalování dokladů
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <v-data-table
        v-model="customer.selected"
        :headers="userHeadersByRole"
        :items="customer.items"
        :options.sync="customer.options"
        :server-items-length="customer.serverItemsLength"
        :loading="customer.loading"
        item-key="id"
        class="elevation-0"
      >
        <template v-slot:item.createdAt="{ item }">
          <DateTime :single-line="false" :datetime="item.createdAt" />
        </template>
        <template v-slot:item.status="{ item }">
          <CustomerDocumentStatus :status="item.status" />
        </template>
        <template v-slot:item.approvedAt="{ item }">
          <DateTime v-if="item.approvedAt" :single-line="false" :datetime="item.approvedAt" />
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn-toggle color="primary" dense group>
            <v-btn
              v-if="item.status.name === 'PENDING'"
              color="blue-grey"
              text
              @click.prevent="openDocumentDialog($event, item)"
            >
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>
            <v-btn color="blue-grey" text @click="openDocument($event, item.file.uuid)">
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </v-btn-toggle>
        </template>
      </v-data-table>
    </v-card-text>
    <CustomerDocumentDialog @customerDocumentComplete="onCustomerDocumentComplete" />
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DateTime from '@/components/DateTime'
import { setFilters } from '@/components/mixins/setFilters'
import { formatPhoneNumber } from '@/components/mixins/formatPhoneNumber'
import arrayBufferToBase64 from '../../../utils/resource'
import CustomerDocumentStatus from '../../../components/customer/CustomerDocumentStatus'
import CustomerDocumentDialog from '../../../components/customer/CustomerDocumentDialog'

export default {
  name: 'CustomerDocuments',
  components: {
    CustomerDocumentDialog,
    CustomerDocumentStatus,
    DateTime,
  },
  mixins: [setFilters, formatPhoneNumber],
  data() {
    return {
      customer: {
        headers: [
          {
            text: 'Datum',
            value: 'createdAt',
            roles: ['ROLE_ADMIN'],
            width: '150px',
          },
          {
            text: 'Id',
            value: 'id',
            roles: ['ROLE_ADMIN'],
            width: '100px',
          },
          {
            text: 'Typ',
            value: 'type.text',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Stav',
            value: 'status',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Schválil',
            value: 'approvedBy',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Schváleno',
            value: 'approvedAt',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: '',
            value: 'actions',
            width: '1px',
            sortable: false,
            roles: ['ROLE_ADMIN'],
          },
        ],
        items: [],
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: ['createdAt'],
          sortDesc: [true],
        },
        loading: false,
        serverItemsLength: 0,
      },
      customerFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    }
  },
  computed: {
    ...mapState({
      authorities: (state) => state.auth.user.authorities,
    }),
    userHeadersByRole() {
      return this.customer.headers.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
  },
  watch: {
    'customer.options': {
      handler() {
        this.loadCustomerDocuments()
      },
    },
    '$route.query': {
      handler() {
        this.loadCustomerDocuments()
      },
    },
  },
  methods: {
    ...mapActions({
      searchCustomerDocuments: 'customer/searchCustomerDocuments',
      getArrayBuffer: 'upload/getArrayBuffer',
    }),
    loadCustomerDocuments() {
      this.customer.loading = true
      const searchParams = {
        filterParams: this.$route.query,
        options: this.customer.options,
      }
      this.customerFooter.selectedData.params = searchParams
      this.searchCustomerDocuments({ id: this.$route.params.customerId, params: searchParams })
        .then((response) => {
          this.customerFooter.totalElements = response.data.totalElements
          this.customer.items = response.data.items
          this.customer.serverItemsLength = response.data.totalElements
          this.cancel = null
        })
        .finally(() => {
          this.customer.loading = false
        })
    },
    setFiltersAction(filters) {
      this.customer.options.page = 1
      this.setFilters(filters)
    },
    openDocument(event, uuid) {
      this.loading = true
      this.getArrayBuffer(uuid)
        .then((response) => {
          let w = window.open('')
          let image = new Image()
          image.src = 'data:application/octet-stream;base64,' + arrayBufferToBase64(response.data)
          setTimeout(function () {
            w.document.write(image.outerHTML)
          }, 0)
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDocumentDialog(event, document) {
      this.$eventBus.$emit('customerDocumentDialog', true, document)
    },
    onCustomerDocumentComplete(confirmed) {
      this.loadCustomerDocuments()
      if (confirmed) {
        this.$emit('documentConfirmed')
      }
    },
  },
}
</script>
